import React from 'react';
import { formatTime, getZonedDate } from './utils';
import { useTheme } from '../../theme/ThemeContext';

interface TimeGutterProps {
  timeSlots: string[];
  HOUR_HEIGHT: number;
  hoursRangeForWeek: { start: number; end: number };
  nowTick: number;
  width?: number;
}

export const TimeGutter: React.FC<TimeGutterProps> = ({ timeSlots, HOUR_HEIGHT, hoursRangeForWeek, nowTick, width = 72 }) => {
  const { tokens } = useTheme();
  const totalHeight = (hoursRangeForWeek.end - hoursRangeForWeek.start) * HOUR_HEIGHT;
  const compact = width < 60;
  return (
    <div style={{ width, flexShrink: 0, position: 'relative', minHeight: totalHeight }}>
      {timeSlots.map((t) => (
        <div key={t} style={{ height: HOUR_HEIGHT, fontSize: compact ? 11 : 15, color: tokens.calendar.muted, textAlign: 'right', boxSizing: 'border-box', position: 'relative' }}>
          <span style={{ position: 'absolute', top: 4, right: 4 }}>{t}</span>
        </div>
      ))}
      {(() => {
        const now = getZonedDate(new Date(nowTick));
        const hour = now.getHours() + now.getMinutes() / 60;
        const within = hour >= hoursRangeForWeek.start && hour < hoursRangeForWeek.end;
        if (!within) return null;
        const nowTop = (hour - hoursRangeForWeek.start) * HOUR_HEIGHT;
        return (
          <div style={{ position: 'absolute', top: nowTop, left: 0, right: 0, zIndex: 40 }}>
            <div style={{ height: 2, background: '#ff4d4f' }} />
            <div style={{ position: 'absolute', top: -10, right: compact ? 2 : 4, background: '#ff4d4f', color: '#fff', borderRadius: 4, padding: compact ? '1px 2px' : '1px 4px', fontSize: compact ? 9 : 10 }}>
              {formatTime(now)}
            </div>
          </div>
        );
      })()}
    </div>
  );
};
